import Spinner from 'components/Spinner';
import MakeEmptyState from '../MakeEmptyState';
import { useCheckSocialShareStatistics } from '../state';
import { useFetchNewSocialStats } from '../useFetchNewSocialStats';
import AllVideosTableContainer from './AllVideosTableContainer';
import {
  VIDEOS_EMPTY_STATE_DESCRIPTION,
  VIDEOS_EMPTY_STATE_TITLE,
} from './constants';

type HeadlinerVideosProps = {};

const HeadlinerVideos: React.FC<HeadlinerVideosProps> = () => {
  const { requestStatus } = useFetchNewSocialStats();

  const { data: hasData } = useCheckSocialShareStatistics(requestStatus);

  if (hasData === undefined) return <Spinner />;

  if (hasData) {
    return <AllVideosTableContainer />;
  }

  return (
    <MakeEmptyState
      title={VIDEOS_EMPTY_STATE_TITLE}
      description={VIDEOS_EMPTY_STATE_DESCRIPTION}
      cta="return to your videos"
    />
  );
};
export default HeadlinerVideos;
